// ----------------------------------------------------------------------------
// Snippet: Video Player
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// ----------------------------------------------------------------------------
// Video-Block (Helpers)
// ----------------------------------------------------------------------------

$(document).ready(function(){
    var CONTROLS_PLAY   = '.video-block__control--play';
    var CONTROLS_PAUSE  = '.video-block__control--pause';

    // Prepare Control Interactions
    var videoBlockControls = {
        play: function(videoBlock) {
            $(videoBlock)
                .removeClass('video-block--is-postered') // Remove the poster (if present)
                .removeClass('video-block--is-paused')   // Indicate video is playing (i.e. not paused)
            ;
        },
        pause: function(videoBlock) {
            $(videoBlock)
                .addClass('video-block--is-paused')
                .addClass('video-block--is-postered') // Indicate video is paused
            ;
        }
    };


    // Manage Custom Controls via video-block events
    $('.video-block').each(function() {

        // Bind Listeners for Custom Controls
        // -------------------------------------------------------------------
        $(this).on('onplay.video-block', function() {
            videoBlockControls.play(this);
        });

        // Bind Play button
        $(this).find(CONTROLS_PLAY).on('click', function() {
            videoBlockControls.play($(this).parents('.video-block')); // Provide immediate feedback (since video might need to queue before callback fires)

            $(this).parents('.video-block').trigger('play.video-block');
        });

        $(this).find(CONTROLS_PAUSE).on('click', function() {
            videoBlockControls.pause($(this).parents('.video-block')); // Provide immediate feedback (since video might need to queue before callback fires)

            $(this).parents('.video-block').trigger('pause.video-block');
        });

        // Play Video on keypress
        $(this).find(CONTROLS_PLAY).on('keypress', function(e) {

            if (e.key == "Enter") {
                e.preventDefault();

                videoBlockControls.play($(this).parents('.video-block')); // Provide immediate feedback (since video might need to queue before callback fires)
                $(this).parents('.video-block').trigger('play.video-block');

                $(this).siblings(CONTROLS_PAUSE).focus();
            }
        });

        // Pause Video on keypress
        $(this).find(CONTROLS_PAUSE).on('keypress', function(e) {

            if (e.key == "Enter") {
                e.preventDefault();

                videoBlockControls.pause($(this).parents('.video-block')); // Provide immediate feedback (since video might need to queue before callback fires)
                $(this).parents('.video-block').trigger('pause.video-block');

                $(this).siblings(CONTROLS_PLAY).focus();
            }
        });
    });



    // ----------------------------------------------------------------------------
    // YouTube Video
    // ----------------------------------------------------------------------------
    var youtubeVideo = {

        init: function() {
            // Load YouTube API and when it's ready, init the players
            var tag = document.createElement('script');
            var firstScriptTag = document.getElementsByTagName('script')[0];

            tag.src = 'https://www.youtube.com/iframe_api';
            firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

            window.onYouTubeIframeAPIReady = function() {
                youtubeVideo.initVideos();
            };
        },

        initVideos: function() {

            // Initialize YouTube Videos
            $('.video-block--youtube').each(function() {
                var video            = youtubeVideo.getVideo(this);
                var video_iframe     = $(video).append('<div />').find('div').get(0);
                var video_settings   = $(video).data('video-settings');

                var video_id         = video_settings.video_id;

                // Initialize YouTube Player
                // Docs: https://developers.google.com/youtube/player_parameters#Parameters
                var player = new YT.Player(video_iframe, {
                    videoId: video_id,
                    playerVars: {
                        playlist:       video_settings.playlist_id == null && video_settings.is_looped ? video_id : null, // Workaround for looping a single video
                        loop:           video_settings.is_looped   ? 1 : 0,
                        autoplay:       video_settings.is_autoplay ? 1 : 0,
                        controls:       video_settings.is_controls ? 1 : 0,
                        disablekb:      video_settings.is_controls ? 0 : 1,
                        playsinline:    video_settings.is_autoplay ? 1 : 0, // Play the video inline (not fullscreen) on iOS with autoplay enabled
                        showinfo:       0,  // Hide video title / uploader overlay
                        modestbranding: 1,  // Minimize YouTube branding
                        fs:             1,  // Enable "full screen"
                        cc_load_policy: 0,  // Disable closed captions by default
                        iv_load_policy: 3,  // Disable video annotations by default
                        rel:            0   // Disable "related videos" from other channels after playing (related videos cannot be disabled fully since September 2018)
                    },
                    events: {
                        'onReady':       youtubeVideo.onPlayerReady
                    }
                });
            });
        },

        onPlayerReady: function(event) {
            var player         = event.target;
            var video          = youtubeVideo.getVideo(player.getIframe());
            var video_settings = $(video).data('video-settings');

            // Sets the initial player volume
            player.setVolume(video_settings.is_muted ? 0 : 100);


            // Bind Custom Controls
            $(video).parents('.video-block').on('play.video-block',   { player: player }, youtubeVideo.play);
            $(video).parents('.video-block').on('pause.video-block',   { player: player }, youtubeVideo.pause);

            // Disable tab focus on iframe on page load
            $(video).parents('.video-block').find('iframe').attr('tabindex', -1);
        },

        play: function(event) {
            // Enable tab focus for video iframe when playing video
            $(this).find('iframe').attr('tabindex', 0);

            event.data.player.playVideo();
        },

        pause: function(event) {
            event.data.player.pauseVideo();
        },

        getVideo: function(element) {
            return $(element).closest('.video-block').find('.video-block__video').get(0);
        }
    };

    // Initialize YouTube Video
    youtubeVideo.init();

    // ----------------------------------------------------------------------------
    // Vimeo Video
    // ----------------------------------------------------------------------------

    var vimeoVideo = {

        init: function() {
            // Initialize Vimeo Videos
            $('.video-block--vimeo').each(function() {
                var video            = $(this).find('.video-block__video').get(0);
                var video_settings   = $(video).data('video-settings');
                var video_id         = Number(video_settings.video_id);


                // Initialize any "Default Posters"
                if (video_settings.lookup_poster) {
                    var url = 'https://vimeo.com/api/v2/video/' + video_id + '.json';

                    fetch(url)
                    .then(response => response.json())
                    .then(data => {
                        //Show the poster
                        $(video).parents('.video-block')
                            .addClass('video-block--is-postered')
                            .css('background-image', 'linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), url(' + data[0].thumbnail_large + ')')
                    ;
                    })
                    .catch((error) => {
                        // Clean up, just in case
                        $(video).parents('.video-block')
                            .removeClass('video-block--is-postered')
                            .css('background-image', '')
                        ;
                    });

                }

                // Initialize Vimeo Player
                // Docs: https://github.com/vimeo/player.js#embed-options
                var player = new Vimeo.Player(video, {
                    id:        video_id,
                    loop:      video_settings.is_looped,
                    autoplay:  video_settings.is_autoplay,
                    autopause: !video_settings.is_autoplay,
                    title:     false,
                    portrait:  false,
                    byline:    false,
                    controls:  video_settings.is_controls
                });

                // Sets the initial player volume
                player.setVolume(video_settings.is_muted ? 0 : 1);


                // Listen to Vimeo "events" and update the Custom Controls accordingly
                player.on('play', function(data) {
                    $(this.element).parents('.video-block').trigger('onplay.video-block');
                });


                // Bind Custom Controls
                $(this).on('play.video-block',   { player: player }, vimeoVideo.play);
                $(this).on('pause.video-block',  { player: player }, vimeoVideo.pause);
            });
        },

        play: function(event) {
            event.data.player.play();
        },

        pause: function(event) {
            event.data.player.pause();
        }
    };

    // Initialize HTML5 Video
    vimeoVideo.init();

    var html5Video = {
        init: function() {
            this.bindEventListeners();
        },

        play: function(event) {
            event.data.player.play();
        },

        pause: function(event) {
            event.data.player.pause();
        },

        bindEventListeners: function() {
            // Bind Listeners for Custom Controls
            $('.video-block--html5').each(function() {
                $(this).on('play.video-block',   { player: html5Video.getPlayer(this) }, html5Video.play);
                $(this).on('pause.video-block',  { player: html5Video.getPlayer(this) }, html5Video.pause);
            });

            // Bind Listeners for HTML5 Video Events
            $('.video-block--html5 .video-block__video').each(function() {
                this.onplay = function() {
                    $(this).parents('.video-block').trigger('onplay.video-block');
                };

                this.onpause = function() {
                    $(this).parents('.video-block').trigger('onpause.video-block');
                };

                this.onended = function() {
                    $(this).parents('.video-block').trigger('onended.video-block');
                };
            });
        },

        getPlayer: function(element) {
            return $(element).find('.video-block__video').get(0);
        }
    };

    // Initialize HTML5 Video
    html5Video.init();
});
